<template>
    <div class="dropdown show">
        <a class="dropdown-toggle action-link w-inline-block pointer" href="#" role="button" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <div class="dropdown-icon-wrap mr">
                <i class="fas fa-download"></i>
            </div>
            <div v-if="buttonLabel">
                {{trans('messages.export_button_title')}}
            </div>
        </a>

        <div class="dropdown-menu" aria-labelledby="dropdownMenuLink">
            <a v-if="exportTypes.includes('marlms')" class="dropdown-item pointer" @click="export_element('marlms')">MarLMS Format</a>
            <a v-if="exportTypes.includes('pdf')" class="dropdown-item pointer" @click="export_element('pdf')">PDF</a>
            <a v-if="exportTypes.includes('html5-scorm')" class="dropdown-item pointer" @click="export_element('html5-scorm')">SCORM 1.2</a>
            <a v-if="exportTypes.includes('moodle')" class="dropdown-item pointer" @click="export_element('moodle')">Moodle Backup</a>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ExportButtonMenu",
        mounted() {
        },
        props: {
            elementId : Number,
            elementType : String,
            exportTypes: {
                type: Array,
                default: () => []
            },
            buttonLabel : {
                type : Boolean,
                default : true,
            }
        },
        methods: {
            isNumeric: function (n) {
                return !isNaN(parseFloat(n)) && isFinite(n);
            },
            export_element(type) {
                //console.log(`/api/export/${this.elementType}/${type}/${this.elementId}`)
                if (this.isNumeric(this.elementId) !== false){
                    location.href = `/api/export/${this.elementType}/${type}/${this.elementId}`
                }
                setTimeout(function () {
                    $('body').removeClass('is-loading');
                }, 1000);
            }
        }
    }
</script>

<style scoped>
.dropdown-icon-wrap {
    color: #808080;
}
</style>
